import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

const docMap = {
  privacy: { document: 'privacy', title: 'Privacy Policy' },
  cookies: { document: 'cookies', title: 'Cookie Policy' },
  terms: { document: 'terms-of-service', title: 'Terms of Service' },
  'acceptable-use': { document: 'acceptable-use', title: 'Acceptable Use Policy' },
};

export default function LegalPage({ type }) {
  const navigate = useNavigate();
  const config = docMap[type];

  useEffect(() => {
    const scriptId = 'getterms-embed-js';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://gettermscdn.com/dist/js/embed.js';
      script.type = 'text/javascript';
      document.body.appendChild(script);
    } else {
      if (window.GetTerms && typeof window.GetTerms.init === 'function') {
        window.GetTerms.init();
      }
    }
  }, [type]);

  if (!config) return null;

  return (
    <div className="min-h-screen bg-brand-dark">
      <div className="bg-black/80 border-b border-[#222222] py-4 px-8">
        <div className="container mx-auto flex items-center gap-4">
          <img
            src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/minotaur-solutions.com/wp-content/uploads/2024/12/logo-0-e1733737765551.webp?bwp"
            alt="Minotaur Solutions"
            className="h-10 w-auto object-contain"
          />
        </div>
      </div>

      <div className="container mx-auto px-8 py-16 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-brand-orange transition-colors mb-10 group"
        >
          <SafeIcon icon={FiArrowLeft} className="text-lg group-hover:-translate-x-1 transition-transform" />
          Back to Home
        </button>

        <h1 className="text-3xl md:text-4xl font-bold text-white mb-10">{config.title}</h1>

        <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-8 md:p-12 text-gray-300 leading-relaxed">
          <div
            className="getterms-document-embed"
            data-getterms="AlogN"
            data-getterms-document={config.document}
            data-getterms-lang="en-au"
            data-getterms-mode="direct"
            data-getterms-env="https://gettermscdn.com"
          />
        </div>
      </div>

      <div className="border-t border-[#222222] py-8 text-center">
        <p className="text-gray-600 text-sm">
          Copyright © Minotaur Solutions BV 2005 - {new Date().getFullYear()}. All rights reserved.
        </p>
      </div>
    </div>
  );
}